<div class="grid-container">
    <div class="toWager">
        <button class="wager" mat-raised-button (click)="selectToWager()" id='TO_WAGER'>Bet To Wager Amount</button>
    </div>
    <div class="toWin">
        <button class="wager" mat-raised-button (click)="selectToWin()" id='TO_WIN' selected>Bet To Win Amount</button>
    </div>
  </div>